import { render, staticRenderFns } from "./ResetPw.vue?vue&type=template&id=d2f8c2a0"
import script from "./ResetPw.vue?vue&type=script&lang=js"
export * from "./ResetPw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports